import { parseBrandBackground } from '@vedalib/editor/lib/brand'
import cn from 'classnames'
import lodash from 'lodash'
import React from 'react'

import { useGetBgImageStyles } from 'components/Course/useGetBgImageStyles'
import { DEFAULT_DESKTOP_WIDTH } from 'components/Editor/DeviceEmulator/constants'
import { getRootNode } from 'components/Editor/EditorContext/selectors/block'
import { useBrandTheme } from 'services/Branding/hooks'
import { DeviceMode } from 'services/Store/Project/enums'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getSection } from 'services/Store/Project/selectors'
import type { Block, IBlockMode } from 'services/Store/Project/types'
import { testProps } from 'utils/test/qaData'

import Node from '../../Node'
import * as s from './SkeletonBlock.module.scss'

interface ISkeletonBlockProps {
  block: Block
  mode: IBlockMode
  index: number
  isActive?: boolean
  center?: boolean
  width?: number
}

const SkeletonBlock = React.forwardRef<HTMLDivElement, ISkeletonBlockProps>(
  ({ block, index, mode, center }, ref) => {
    const root = getRootNode(block)
    const maxWidth = root?.style?.[DeviceMode.desktop]?.maxWidth || DEFAULT_DESKTOP_WIDTH
    const theme = useBrandTheme()
    const section = useProjectContext(getSection)
    const sectionBackground = parseBrandBackground(section?.style?.background || theme?.background)
    const imgStyles = useGetBgImageStyles(sectionBackground.overlay)
    const colorStyles = lodash.pick(imgStyles, ['backgroundColor', '--overlay'])

    return (
      <div
        {...testProps({ el: 'block', name: block.name, id: block.uuid, index, sourceTemplateId: block.options?.sourceTemplateId })}
        className={cn(s.canvas, { [s.center]: center })}
        ref={ref}
        style={{
          width: maxWidth,
          backgroundColor: sectionBackground.color || '',
          ...colorStyles,
        }}
      >
        <Node block={block} id={root.id} mode={mode} />
      </div>
    )
  },
)

SkeletonBlock.displayName = 'SkeletonBlock'

export default SkeletonBlock
